import { flow, Instance, types, getParent, applySnapshot } from 'mobx-state-tree';
import { DateTime } from 'luxon';

import { removeMeet, updateMeet } from '@common/api/meets';
import Student from '@common/models/Users/Students/Student';
import Parent from '@common/models/Users/Parents/Parent';

import { IReworkingMeetsModel } from './ReworkingMeets';

const Meet = types
	.model('Meet',
	{
		id: types.identifierNumber,
		location: types.frozen(),
		service_id: types.number,
		end_dt: types.string,
		start_dt: types.string,
		status: types.maybeNull(types.number),
		teacher: types.maybeNull(types.frozen()),
		student: types.maybeNull(Student),
		parent: types.maybeNull(Parent),
		meetSlot: types.frozen(),
		programGroup: types.frozen(),
		gradebook: types.frozen(),
		type: types.maybeNull(types.optional(types.string, 'working_off')),
		zoom_access_code: types.maybeNull(types.string),
		zoom_id: types.maybeNull(types.string),
		zoom_link: types.maybeNull(types.string),
		comment_teacher: types.maybeNull(types.string),
		comment_student: types.maybeNull(types.string),
		phone: types.maybeNull(types.string),
		format: types.optional(types.string, 'offline'),
	})
	.views((self) => ({
		get startDateTime() {
			return DateTime.fromSQL(self.start_dt);
		},
		get endDateTime() {
			return DateTime.fromSQL(self.end_dt);
		},
	}))
	.views((self) => ({
		get weekday(): number {
			return self.startDateTime.weekday;
		},
		get hourNumber(): number {
			return self.startDateTime.hour;
		},
		get hourSlotNumber() {
			return Math.floor(self.startDateTime.minute / 20); // @TODO: Const
		},
		get timesString() {
			return `${self.startDateTime.toLocaleString(DateTime.TIME_24_SIMPLE)} - ${self.endDateTime.toLocaleString(DateTime.TIME_24_SIMPLE)}`;
		},
		get lessonSlotNumber(): number {
			const parent = getParent(self, 2) as IReworkingMeetsModel;
			const shift = parent.minHour * parent.slotsInHour - 1;
			return (self.startDateTime.hour + self.startDateTime.minute / 60) * parent.slotsInHour
				- shift;
		},
	}))
	.actions((self) => ({
		save: flow(function* (data: any) {
			const result = yield updateMeet(self.id, data);
			applySnapshot(self, result);
		}),
		remove: flow(function* () {
			yield removeMeet(self.id);
			const parent = getParent(self, 2) as IReworkingMeetsModel;
			parent.removeMeet(self);
		}),
	}));

export default Meet;

export interface IReworkingMeetModel extends Instance<typeof Meet> {}
